import React, { useEffect, useState } from 'react';
import { sendAppDeletedFromDeleteModalBiEvent, sendCanceledAppDeletionInDeleteModalBiEvent, sendDeleteModalClickOnCustomerCareBiEvent, sendDeleteModalOpenedBiEvent, } from '../../../bi/biEvents';
import { Box, CustomModalLayout, Dropdown, FormField, InputArea, MessageBoxFunctionalLayout, Modal, Text, } from 'wix-style-react';
import { cancelTestPlan } from '../../../api';
import { appHasEditor, getAppPages, isPremiumFromBundle } from '../../..';
import { Trans } from 'react-i18next';
import { RenewalType, } from '@wix/ambassador-marketplace/types';
function getShuffledDropDownOptions(updateDropDownOptions) {
    return updateDropDownOptions
        .map(function (option) {
        return {
            option: option,
            sort: option.id === 'other' ? 1 : Math.random(),
        };
    })
        .sort(function (a, b) {
        return a.sort - b.sort;
    })
        .map(function (_a) {
        return _a.option;
    });
}
function getPublishedAppDropDownOptions(updateDropDownOptions) {
    return updateDropDownOptions.filter(function (option) { return option.id !== 'removed-from-market'; });
}
export var DeleteDashboardModal = function (_b) {
    var app = _b.app, msId = _b.msId, origin = _b.origin, t = _b.t, handleClose = _b.handleClose, handleDeleteApp = _b.handleDeleteApp, editorType = _b.editorType, baseUrl = _b.baseUrl, authorizationHeader = _b.authorizationHeader, experiments = _b.experiments, showNotification = _b.showNotification;
    var shuffleDropDownOptions = experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.manage-apps.shuffle-delete-modal-options-order');
    var deleteModalDropDownOptions = [
        {
            id: 'dont-need-anymore',
            value: t('manage-apps.delete-modal.option-dont-need-anymore'),
        },
        {
            id: 'missing-needed-features',
            value: t('manage-apps.delete-modal.option-missing-needed-features'),
        },
        { id: 'tried-out', value: t('manage-apps.delete-modal.option-tried-out') },
        {
            id: 'technical-issue',
            value: t('manage-apps.delete-modal.option-technical-issue'),
        },
        {
            id: 'found-alternative-solution',
            value: t('manage-apps.delete-modal.option-found-alternative-solution'),
        },
        {
            id: 'added-by-mistake',
            value: t('manage-apps.delete-modal.option-added-by-mistake'),
        },
        {
            id: 'too-expensive',
            value: t('manage-apps.delete-modal.option-too-expensive'),
        },
        {
            id: 'removed-from-market',
            value: t('manage-apps.delete-modal.option-removed-from-market'),
        },
        {
            id: 'didnt-add-it',
            value: t('manage-apps.delete-modal.option-didnt-add-it'),
        },
        { id: 'other', value: t('manage-apps.delete-modal.option-other') },
    ];
    var appName = app.webSolutionBase.name;
    var appId = app.webSolutionBase.id;
    var _c = useState(''), deletionReason = _c[0], setDeletionReason = _c[1];
    var _d = useState(false), hasCounter = _d[0], setHasCounter = _d[1];
    var _e = useState(deleteModalDropDownOptions), dropDownOptions = _e[0], setDropDownOptions = _e[1];
    var onSelectDeletionReason = function (option) { return setDeletionReason(option.id); };
    var isDeletionReasonSelected = Boolean(deletionReason);
    var _f = useState(''), deletionDetails = _f[0], setDeletionDetails = _f[1];
    var onChangeDeletionDetails = function (event) {
        if (event.target.value.length <= 500) {
            setDeletionDetails(event.target.value);
        }
    };
    var getNote = function () {
        var isUninstallActionAppRemoveProducts = app.uninstallAction && app.uninstallAction === 'REMOVE_ALL_PRODUCT';
        var isUninstallActionAppShippingRates = app.uninstallAction && app.uninstallAction === 'SHIPPING_RATES_REGION';
        if (isUninstallActionAppShippingRates) {
            return t('manage-apps.delete-modal.note-description-shipping-region', {
                appName: appName,
            }).replace('&amp;', '&');
        }
        if (isUninstallActionAppRemoveProducts) {
            return t('manage-apps.delete-modal.note-description-custom-store', {
                appName: appName,
            }).replace('&amp;', '&');
        }
        if (isPremiumFromBundle(app)) {
            return t('manage-apps.delete-modal.note-description-bundle-app', {
                appName: appName,
            }).replace('&amp;', '&');
        }
        if (appHasEditor(app) && getAppPages(app).length) {
            return t('manage-apps.delete-modal.note-description-page-app', {
                appName: appName,
            }).replace('&amp;', '&');
        }
        if (appHasEditor(app)) {
            return t('manage-apps.delete-modal.note-description-editor-app', {
                appName: appName,
            }).replace('&amp;', '&');
        }
        return t('manage-apps.delete-modal.note-description', {
            appName: appName,
        }).replace('&amp;', '&');
    };
    var deleteAppAndCloseModal = function () {
        handleDeleteApp(app, showNotification);
        var reasonIndex = dropDownOptions.findIndex(function (option) { return option.id === deletionReason; });
        if (app.isTestPlan) {
            cancelTestPlan(baseUrl, app.webSolutionBase.id, app.vendorProductId, authorizationHeader).catch(function (error) { return console.log(error); });
        }
        sendAppDeletedFromDeleteModalBiEvent(appId, msId, origin, deletionReason, deletionDetails, reasonIndex, editorType);
        handleClose();
    };
    var cancelDeletionAndCloseModal = function () {
        sendCanceledAppDeletionInDeleteModalBiEvent(appId, msId, origin, editorType);
        handleClose();
    };
    var inputAreaCharCounter = (React.createElement(Text, { size: "small", weight: "normal", light: true, secondary: true },
        deletionDetails.length,
        "/500"));
    useEffect(function () {
        sendDeleteModalOpenedBiEvent(appId, msId, origin, editorType);
        var updateDropDownOptions = dropDownOptions;
        var isAppPublished = app.publishedVersion !== '';
        if (isAppPublished) {
            updateDropDownOptions = getPublishedAppDropDownOptions(updateDropDownOptions);
        }
        if (shuffleDropDownOptions) {
            updateDropDownOptions = getShuffledDropDownOptions(updateDropDownOptions);
        }
        setDropDownOptions(updateDropDownOptions);
    }, []);
    var DeleteModalSubtitleWithLink = function () { return (React.createElement(Text, { secondary: true },
        React.createElement(Trans, { i18nKey: 'manage-apps.delete-modal.subtitle-with-link' },
            "prefix(0)",
            React.createElement("a", { href: t('manage-apps.delete-modal.link'), target: "_blank", onClick: function () {
                    return sendDeleteModalClickOnCustomerCareBiEvent(appId, msId, origin, editorType);
                } }, "link(1)")))); };
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(CustomModalLayout, { width: "600px", theme: "destructive", title: t('manage-apps.delete-modal.title', { appName: appName }).replace('&amp;', '&'), subtitle: shuffleDropDownOptions ? (React.createElement(DeleteModalSubtitleWithLink, null)) : (t('manage-apps.delete-modal.subtitle')), primaryButtonText: t('manage-apps.delete-modal.primary-button'), primaryButtonOnClick: deleteAppAndCloseModal, primaryButtonProps: { disabled: !isDeletionReasonSelected }, secondaryButtonText: t('manage-apps.delete-modal.secondary-button'), secondaryButtonOnClick: cancelDeletionAndCloseModal, onCloseButtonClick: cancelDeletionAndCloseModal, dataHook: 'delete-modal' },
            React.createElement(Box, { direction: "vertical" },
                React.createElement(FormField, { label: t('manage-apps.delete-modal.dropdown-title'), required: true },
                    React.createElement(Dropdown, { placeholder: t('manage-apps.delete-modal.dropdown-placeholder'), options: dropDownOptions, onSelect: onSelectDeletionReason, maxHeightPixels: 180, dataHook: 'delete-modal-dropdown' })),
                React.createElement(Box, { margin: "30px 0", direction: "vertical" },
                    React.createElement(FormField, { label: t('manage-apps.delete-modal.input-area-title'), suffix: hasCounter ? inputAreaCharCounter : '' },
                        React.createElement(InputArea, { placeholder: t("manage-apps.delete-modal.input-area-placeholder" + (shuffleDropDownOptions ? '2' : '')), value: deletionDetails, onChange: onChangeDeletionDetails, onFocus: function () { return setHasCounter(true); }, onBlur: function () { return setHasCounter(false); } }))),
                React.createElement(Text, { weight: "bold", size: "small" },
                    t('manage-apps.delete-modal.note'),
                    ' ',
                    React.createElement(Text, { size: "small", weight: "thin" }, getNote()))))));
};
export var deleteDashBoardAppContent = function (app, t, experiments) {
    var premiumRenewlOff = app.isUpgraded && app.premiumAutoRenew !== RenewalType.AUTO_RENEW_ON;
    var isUninstallActionApp = app.uninstallAction && app.uninstallAction === 'REMOVE_ALL_PRODUCT';
    var UninstallActionFT = experiments.enabled('specs.marketplace.unInstallAction');
    if (premiumRenewlOff) {
        return t('manage-apps.delete-dashboard-still-active-premium-line2');
    }
    if (isUninstallActionApp && UninstallActionFT) {
        return t("manage-apps.delete-dashboard-" + app.uninstallAction + "-cancel-line2");
    }
    return t('manage-apps.delete-dashboard-cancel-line2');
};
export var renderDeleteDashboardModalOld = function (app, t, handleClose, manageAppsStaticsUrl, handleDeleteApp, content) {
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageBoxFunctionalLayout, { title: t('manage-apps.delete-dashboard-header'), confirmText: t('manage-apps.delete-dashboard-cta'), theme: "red", closeButton: true, image: React.createElement("img", { src: manageAppsStaticsUrl + "assets/delete.svg" }), cancelText: t('manage-apps.delete-dashboard-cancel'), onCancel: handleClose, onOk: function (ev) {
                handleDeleteApp(app, false);
                handleClose();
            } },
            t('manage-apps.delete-dashboard-cancel-line1', {
                name: app.webSolutionBase.name,
            }).replace('&amp;', '&'),
            React.createElement("br", null),
            content)));
};
//# sourceMappingURL=delete-dashboard-modal.js.map